import util from "../../util";

const div = $("#planCodeSearchDiv");
const searchButton = $("#planCodeSearchButton");
const planCodeSearchTitle = $("#planCodeSearchTitle");

let originalTitle = "";
let originalSearchButtonHtml = "";
let unionMemberPlanDocumentsSearch = "";

if (div.length) {
  originalTitle = planCodeSearchTitle.html();
  originalSearchButtonHtml = searchButton.html();
  unionMemberPlanDocumentsSearch = $("#unionMemberPlanDocumentsSearch");

  $("body").on("click", "#planCodeSearchButton", (e) => {
    e.preventDefault();
    if (unionMemberPlanDocumentsSearch.val().length > 0) {
      searchButton.html($("#hidPlanDocumentsSearchingText").val());
      util.removeCardErrorMessage(div);
      const searchUrl = `/api/plan-documents/search/${unionMemberPlanDocumentsSearch.val()}`;
      fetch(searchUrl)
        .then((res) => {
          if (res.status !== 400 && res.status !== 200) {
            throw Error(res.status + " " + res.statusText);
          }
          return res.json();
        })
        .then((res) => {
          if (
            typeof res !== "undefined" &&
            res !== null &&
            res.length &&
            typeof res[0].PlanContent !== "undefined" &&
            res[0].PlanContent !== null &&
            res[0].PlanContent.length
          ) {
            const groups = res[0].PlanContent[0].Groups;
            let planDocumentHtml = `<div class="infoCol"><ul class="infoList infoList--withDividers infoList--withOnlyContentLinks">`;
            for (let i = 0; i < groups.length; i++) {
              planDocumentHtml += `<li>
                    <div class="infoList__header">
                      <h5 class="infoList__title">${groups[i].Title}</h5>
                    </div>
                    <div class="infoList__content">`;
              for (let y = 0; y < groups[i].Documents.length; y++) {
                planDocumentHtml += `<a href="${groups[i].Documents[y].Url}" target="_blank" class="textLink textLink--tiny textLink--withIcon textLink--withIcon--left">
                        <i class="icon icon-file-pdf-1 "></i>  
                        ${groups[i].Documents[y].Title}
                      </a><br/>`;
              }
              planDocumentHtml += `</div></li>`;
            }
            planDocumentHtml += `</ul></div>`;
            $("#planCodeSearchResults").html(planDocumentHtml);
            $("#planCodeSearchForm").addClass("hide");
            $("#planCodeSearchDescription").addClass("hide");
            planCodeSearchTitle.html(
              $("#hidPlanDocumentsTitleAfterSearch").val() +
                " " +
                unionMemberPlanDocumentsSearch.val()
            );
            $("#planCodeSearchTitle")
              .after(`<div class="subPanelHeader__actions" id="planCodeSearchAgainDiv">
                        <a href="" class="textLink textLink--small textLink--withIcon textLink--withIcon--left nowrap" id="planCodeSearchAgainLink">
                            <i class="icon icon-${$(
                              "#hidPlanDocumentsSearchButtonIcon"
                            ).val()}"></i>
                            <span class="text">${$(
                              "#hidPlanDocumentsNewSearchText"
                            ).val()}</span>
                        </a>
                    </div>`);
          } else {
            util.showCardErrorMessage(
              div,
              true,
              $("#hidPlanDocumentsCustomErrorMessage").val(),
              true
            );
          }
          searchButton.html(originalSearchButtonHtml);
        })
        .catch((error) => {
          util.showCardErrorMessage(div, true, null, true);
          searchButton.html(originalSearchButtonHtml);
        });
    }
  });

  $("body").on("click", "#planCodeSearchAgainLink", (e) => {
    e.preventDefault();
    planCodeSearchTitle.html(originalTitle);
    $("#planCodeSearchAgainDiv").remove();
    $("#planCodeSearchForm").removeClass("hide");
    $("#planCodeSearchDescription").removeClass("hide");
    $("#planCodeSearchResults").html("");
    unionMemberPlanDocumentsSearch.val("").focus();
  });

  unionMemberPlanDocumentsSearch
    .on("keypress", (e) => {
      var key = e.which;
      if (key === 13) {
        // the enter key code
        searchButton.click();
        return false;
      }
    })
    .on("keyup", (e) => {
      var key = e.which;
      if (key !== 13) {
        // the enter key code
        util.removeCardErrorMessage(div);
      }
    });
}
